import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'

const Bubble = ({ maxW = "400px", gap = "30px", padding = "30px", bg = "var(--modal-background)", children, motion, id = null, bottom = "false" }) => {

    return (
        <Wrap id={id} $maxW={maxW} $padding={padding} $gap={gap} $bg={bg} $bottom={bottom} {...motion} >{children}</Wrap>
    )
}

export default Bubble

const Wrap = styled(motion.div).attrs(() => ({
    initial: false,
}))`
    z-index: 101;
    width: 100%;
    max-width: ${(props) => (props.$maxW)};
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: end;       
    border-radius: 6px;
    flex-direction: column;
    gap: ${(props) => (props.$gap)};
    padding: ${(props) => (props.$padding)};
    filter: drop-shadow(0 2px 8px var(--border-med));
    outline: 1px solid var(--border-med);
    background: ${(props) => (props.$bg)};
    pointer-events: auto;

    @media(prefers-color-scheme: dark) {
        filter: drop-shadow(0 2px 8px var(--border-med));
    }
    
    @media(width > 768px) {
    padding: ${(props) => (props.$padding)};
        
    }
`
